
import { FormatMoney } from 'format-money-js'

export const useCurrencyFormat = () => {

    const formatToMoney = (number) => {
        const fm = new FormatMoney({
            decimals: 2
        });
        let money = fm.from(number, { symbol: '$' })
        //console.log(number)
        return money;
    }

    const formatWithCurrencyISO = (number, code) => {

        let currency = {
            '484': "MXN",
            "840": "USD",
            "default": ""
        }

        let formatNumber = formatToMoney(number);
        let currencyISO = currency[code] ? currency[code] : currency['default']
        //console.log(`${formatNumber} ${currencyISO}`)
        return `${!formatNumber ? "$0.00" : formatNumber} ${!formatNumber ? "" : currencyISO}`
    }

    return { formatToMoney, formatWithCurrencyISO }

}